import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BackgroundColorIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BackgroundColor",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.27 13.83 16.48 3.05c-.3-.29-.72-.48-1.17-.48s-.87.18-1.17.48L3.44 13.7C2.55 14.59 2 15.82 2 17.18s.55 2.59 1.44 3.48l6.22 6.21c.89.89 2.12 1.44 3.48 1.44s2.59-.55 3.48-1.44l10.66-10.66c.3-.3.49-.72.49-1.19s-.19-.88-.49-1.19ZM15.3 6.6l8.26 8.26H7.02l8.27-8.26Zm11.35 12.75-2.24 5.6v3.36h1.12v1.12h3.36v-1.12h1.12v-3.36l-2.24-5.6z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29.43 27.72a1.71 1.71 0 1 1-3.42 0c0-.94 1.71-4 1.71-4s1.71 3.05 1.71 4"
      }), /*#__PURE__*/_jsx("path", {
        d: "M27.71 30.58a2.86 2.86 0 0 1-2.86-2.86c0-1.08 1.17-3.32 1.86-4.56.4-.72 1.59-.72 1.99 0 .69 1.24 1.86 3.48 1.86 4.56a2.86 2.86 0 0 1-2.86 2.86Zm0-4.36c-.33.71-.55 1.29-.57 1.51 0 .3.26.56.57.56s.57-.25.57-.56c-.02-.23-.24-.8-.57-1.5ZM7.71 16.86h10.38l-5.19 5.19z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.9 23.2c-.29 0-.58-.11-.81-.33L6.9 17.68c-.33-.33-.42-.82-.25-1.25.18-.43.59-.71 1.06-.71h10.38c.46 0 .88.28 1.06.71s.08.92-.25 1.25l-5.19 5.19c-.22.22-.52.33-.81.33m-2.43-5.19 2.43 2.43 2.43-2.43z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.88 28.4c-.92 0-1.78-.36-2.42-1.01l-8.6-8.58c-.65-.65-1-1.51-1-2.42s.36-1.78 1-2.42l7.19-7.19a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-7.19 7.19c-.22.22-.33.5-.33.81s.12.59.33.81l8.59 8.59c.22.22.5.34.81.34.3 0 .59-.12.81-.33l8.29-8.29c.21-.21.5-.33.81-.33h1.71L10.15 2.81a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l16.3 16.3c.33.33.42.82.25 1.25-.18.43-.59.71-1.06.71h-4l-7.95 7.96c-.65.65-1.51 1-2.42 1Z"
      })]
    })
  }));
};
BackgroundColorIcon.displayName = 'BackgroundColorIcon';